import axiosClient from "../axiosClient";
import { User } from "../interfaces/user.interface";

export const findUser = async () => {
  const { data } = await axiosClient.get<User>("/users/current-user?complet=true");
  return data;
};

export const peutAccederAuxWebinaires = async () => {
  const { data } = await axiosClient.get<boolean>("/users/peut-acceder-aux-webinaires");
  return data;
};
